import { useCallback } from "react";
import { useLocalStorage } from "./useLocalStorage";
export default function useCache(key, initialValue, isValidEntry) {
  var isValidAndFreshData = useCallback(function (object) {
    if (!isValidEntry(object.value)) return false;
    if (typeof object.timestamp !== "number") return false;
    return object.timestamp > initialValue.timestamp;
  }, [initialValue.timestamp, isValidEntry]);
  var _a = useLocalStorage(key, initialValue, isValidAndFreshData),
    cachedValue = _a[0],
    setCachedValue = _a[1];
  var setValueIfNewer = useCallback(function (newValue) {
    setCachedValue(function (prev) {
      if (typeof newValue === "function") {
        newValue = newValue(prev);
      }
      return newValue.timestamp >= prev.timestamp ? newValue : prev;
    });
  }, [setCachedValue]);
  return [cachedValue.value, setCachedValue, setValueIfNewer];
}